export class CampoModel<T> {
  id: any;
  value: T;
  key: string;
  label: string;
  required: boolean;
  order: number;
  controlType: string;
  pattern: string;
  maxlength: string;

  constructor(
    options: {
      value?: T;
      key?: string;
      label?: string;
      required?: boolean;
      order?: number;
      controlType?: string;
      pattern?: string;
      maxlength?: string;
      id?: number;
    } = {}
  ) {
    this.value = options.value;
    this.key = options.key || "";
    this.label = options.label || "";
    this.required = !!options.required;
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType || "";
    this.pattern = options.pattern || "";
    this.maxlength = options.maxlength || "";
    this.id = options.id || null;
  }
}
